import MainLayout from "../layout";
import Page from "../page/Page";
import { useTranslation } from "react-i18next";
import { Section, Title } from "@vshp/ui-components";

function DiscountsPage() {
  const { t } = useTranslation();
  let title = {
    caption: t("pages.discounts.title"),
  };

  return (
    <MainLayout title={title}>
      <Page title={t("pages.discounts.title")} titleKey="pages.discounts.title">
        <Section textSizeLg={true} border={true}>
          <Section.BodySmall>
            <div data-key="pages.discounts.info" dangerouslySetInnerHTML={{ __html: t("pages.discounts.info") }}></div>
          </Section.BodySmall>
        </Section>

        <Section border={true}>
          <Title type="h2" data-key="pages.discounts.social.title">
            {t("pages.discounts.social.title")}
          </Title>
          <Section.BodySmall>
            <div data-key="pages.discounts.social.text" dangerouslySetInnerHTML={{ __html: t("pages.discounts.social.text") }}></div>
          </Section.BodySmall>
        </Section>

        <Section border={true}>
          <Title type="h2" data-key="pages.discounts.early_payment.title">
            {t("pages.discounts.early_payment.title")}
          </Title>
          <Section.BodySmall>
            <div data-key="pages.discounts.early_payment.text" dangerouslySetInnerHTML={{ __html: t("pages.discounts.early_payment.text") }}></div>
          </Section.BodySmall>
        </Section>

        <Section border={true}>
          <Title type="h2" data-key="pages.discounts.alumni.title">
            {t("pages.discounts.alumni.title")}
          </Title>
          <Section.BodySmall>
            <div data-key="pages.discounts.alumni.text" dangerouslySetInnerHTML={{ __html: t("pages.discounts.alumni.text") }}></div>
          </Section.BodySmall>
        </Section>

        <Section border={true}>
          <Title type="h2" data-key="pages.discounts.family_discount.title">
            {t("pages.discounts.family_discount.title")}
          </Title>
          <Section.BodySmall>
            <div data-key="pages.discounts.family_discount.text" dangerouslySetInnerHTML={{ __html: t("pages.discounts.family_discount.text") }}></div>
          </Section.BodySmall>
        </Section>

        <Section border={true}>
          <Title type="h2" data-key="pages.discounts.active_students.title">
            {t("pages.discounts.active_students.title")}
          </Title>
          <Section.BodySmall>
            <div data-key="pages.discounts.active_students.text" dangerouslySetInnerHTML={{ __html: t("pages.discounts.active_students.text") }}></div>
          </Section.BodySmall>
        </Section>

        <Section border={true}>
          <Title type="h2" data-key="pages.discounts.referral_program.title">
            {t("pages.discounts.referral_program.title")}
          </Title>
          <Section.BodySmall>
            <div data-key="pages.discounts.referral_program.text" dangerouslySetInnerHTML={{ __html: t("pages.discounts.referral_program.text") }}></div>
            <a className="btn btn_primary space_top" href="https://academy.siil.ch/friends" data-key="pages.discounts.referral_program.btn" target="_blank" rel="noreferrer">
              {t("pages.discounts.referral_program.btn")}
            </a>
          </Section.BodySmall>
        </Section>

        <Section>
          <Title type="h2" data-key="pages.discounts.important_information.title">
            {t("pages.discounts.important_information.title")}
          </Title>
          <Section.BodySmall>
            <div data-key="pages.discounts.important_information.text" dangerouslySetInnerHTML={{ __html: t("pages.discounts.important_information.text") }}></div>
          </Section.BodySmall>
        </Section>
      </Page>
    </MainLayout>
  );
}

export default DiscountsPage;
